var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs flex"},_vm._l((_vm.tabList),function(i,j){return _c('div',{key:i.value,staticClass:"tabslist flex ac jc",style:({
        background: _vm.t2value == i.value ? '#1074DB' : 'transparent',
      }),on:{"click":function($event){return _vm.tabschanges(i.value)}}},[(i.img)?_c('img',{staticClass:"imgInl",attrs:{"src":i.img}}):_c('span',[_vm._v(_vm._s(i.label))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }